import React, { FormEvent, useEffect, useState } from 'react';
import { Autocomplete, Button, MenuItem, styled, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import { GuideQueryParams } from './hooks/useFetchGuides';
import FilterBox from 'components/filter-box/FilterBox';
import KeyboardDatePicker from 'components/pickers/KeyboardDatePicker';
import { api } from 'services/api';
import { User } from 'types/user';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '350px 200px 200px 200px 120px 100px',
  columnGap: 10,
  rowGap: 15,
  '& .date-picker': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 10,
  },
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '3fr 1fr 1fr 1fr 100px 100px',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr 1fr',
    '& .date-picker': {
      gridColumn: '1 / -1',
    },
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type GuideFilterBoxProps = {
  filter: GuideQueryParams;
  handleChange(index: keyof GuideQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const GuideFilterBox: React.FC<GuideFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    api
      .get<User[]>('/users/all', { params: { name: '' } })
      .then(response => setUsers(response.data))
      .catch(() => setUsers([]));
  }, []);

  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <div className="date-picker">
          <KeyboardDatePicker
            fullWidth
            label="Consulta de"
            value={filter.initial_date}
            onChange={date => handleChange('initial_date', date)}
          />
          <KeyboardDatePicker
            fullWidth
            label="Consulta até"
            value={filter.final_date}
            onChange={date => handleChange('final_date', date)}
          />
        </div>

        <TextField
          label="Nome do paciente"
          value={filter.patient_name}
          onChange={e => handleChange('patient_name', e.target.value)}
        />
        <TextField
          label="Nome do médico"
          value={filter.doctor_name}
          onChange={e => handleChange('doctor_name', e.target.value)}
        />
        <Autocomplete
          value={users.find(u => u.id === filter.marker_id) || null}
          options={users}
          noOptionsText="Nenhum marcador encontrado"
          getOptionLabel={option => option.name}
          onChange={(_, user) => handleChange('marker_id', user ? user.id : null)}
          renderInput={params => <TextField {...params} label="Marcador" />}
        />

        <TextField
          select
          fullWidth
          label="Status"
          value={filter.status}
          onChange={e => handleChange('status', e.target.value)}
        >
          <MenuItem value="all">Todos</MenuItem>
          <MenuItem value="scheduled">Agendadas</MenuItem>
          <MenuItem value="completed">Concluídas</MenuItem>
          <MenuItem value="no_show">Faltou</MenuItem>
          <MenuItem value="deleted">Canceladas</MenuItem>
        </TextField>

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default GuideFilterBox;
